import React, { useContext, useState } from "react";
import { EligibilityContext } from "../../contexts/EligibilityContext";
import debounce from "lodash/debounce";

// get the document height
const height = Math.max(
  document.body.scrollHeight,
  document.body.offsetHeight,
  document.documentElement.clientHeight,
  document.documentElement.scrollHeight,
  document.documentElement.offsetHeight
);

// 30% of the document height
const oneThirdHeight = height * 0.3;

const Open = () => {
  const context = useContext(EligibilityContext);
  const [visible, setVisible] = useState(false);

  // on scroll, set state to visible if the user has scrolled more than 30%
  // of the way down the page
  window.addEventListener(
    "scroll",
    debounce(() => {
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      // set the viewed pixels to the scroll posititon plus the height of the viewport
      const viewedPixels = scrollPosition + window.innerHeight;

      // if the viewed pixels is more than 30% of the document height, show the component
      if (viewedPixels >= oneThirdHeight) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    }, 300)
  );

  return (
    <div className={`GetHelp ${visible ? "-visible" : ""}`}>
      <button
        className="GetHelp-button"
        onClick={() => context.actions.setModalOpen(true)}
      >
        Apply Now
      </button>
    </div>
  );
};

export default Open;
